export let PaymentDetailsType;

(function (PaymentDetailsType) {
  PaymentDetailsType["Completed"] = "completed";
  PaymentDetailsType["Pending"] = "pending";
  PaymentDetailsType["Failed"] = "failed";
})(PaymentDetailsType || (PaymentDetailsType = {}));

export let DebitStatus;

(function (DebitStatus) {
  DebitStatus[DebitStatus["New"] = 1] = "New";
  DebitStatus[DebitStatus["Processing"] = 10] = "Processing";
  DebitStatus[DebitStatus["Pending"] = 20] = "Pending";
  DebitStatus[DebitStatus["Failed"] = 30] = "Failed";
  DebitStatus[DebitStatus["Authorized"] = 35] = "Authorized";
  DebitStatus[DebitStatus["Success"] = 40] = "Success";
  DebitStatus[DebitStatus["PayoutAvailable"] = 50] = "PayoutAvailable";
  DebitStatus[DebitStatus["PayoutProcessing"] = 60] = "PayoutProcessing";
  DebitStatus[DebitStatus["PayoutFailed"] = 70] = "PayoutFailed";
  DebitStatus[DebitStatus["PayoutDone"] = 80] = "PayoutDone";
  DebitStatus[DebitStatus["PayoutReverted"] = 85] = "PayoutReverted";
  DebitStatus[DebitStatus["PayoutPartiallyRefunded"] = 90] = "PayoutPartiallyRefunded";
  DebitStatus[DebitStatus["Refunded"] = 100] = "Refunded";
})(DebitStatus || (DebitStatus = {}));